import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/primeng';
import { BreadcrumbService, ApplicationService } from '@picard/services-lib';
import { PreAuthenticationResponse } from '@picard/models-lib';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnDestroy {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  subscription: Subscription;
  items: MenuItem[];
  programId: any;
  //#endregion Properties

  //#region Constructor
  constructor(public breadcrumbService: BreadcrumbService, private _applicationService: ApplicationService) {
    this.programId =  parseInt(sessionStorage.getItem('programID')); // this._applicationService.preAuthenticationResponse.programId;
    this.subscription = breadcrumbService.itemsHandler
    .subscribe(response => {
        this.items = response;
    });
  }
  //#endregion Constructor

  //#region Functions
  ngOnDestroy() {
      if (this.subscription) {
          this.subscription.unsubscribe();
      }
  }
  //#endregion Functions
}
